import ApiService from './api';

class AdminService {
  // Get dashboard analytics
  async getDashboardAnalytics() {
    try {
      return await ApiService.get('/admin/analytics/dashboard');
    } catch (error) {
      throw error;
    }
  }

  // Officer Management
  async getOfficers(page = 0, size = 10) {
    try {
      const queryParams = new URLSearchParams({ page, size });
      return await ApiService.get(`/admin/officers?${queryParams.toString()}`);
    } catch (error) {
      throw error;
    }
  }

  async createOfficer(officerData) {
    try {
      return await ApiService.post('/admin/officers', officerData);
    } catch (error) {
      throw error;
    }
  }

  async updateOfficer(id, officerData) {
    try {
      return await ApiService.put(`/admin/officers/${id}`, officerData);
    } catch (error) {
      throw error;
    }
  }

  async deleteOfficer(id) {
    try {
      return await ApiService.delete(`/admin/officers/${id}`);
    } catch (error) {
      throw error;
    }
  }

  // Audit Logs
  async getAuditLogs(filters = {}) {
    try {
      const queryParams = new URLSearchParams();

      Object.keys(filters).forEach((key) => {
        if (filters[key] && filters[key] !== '') {
          queryParams.append(key, filters[key]);
        }
      });

      return await ApiService.get(`/audit-logs?${queryParams.toString()}`);
    } catch (error) {
      throw error;
    }
  }

  async getAuditLogsByUser(userId, page = 0, size = 20) {
    try {
      const queryParams = new URLSearchParams({ page, size });
      return await ApiService.get(
        `/audit-logs/user/${userId}?${queryParams.toString()}`
      );
    } catch (error) {
      throw error;
    }
  }

  async getAuditStatistics(hoursBack = 24) {
    try {
      return await ApiService.get(
        `/audit-logs/statistics?hoursBack=${hoursBack}`
      );
    } catch (error) {
      throw error;
    }
  }

  // Reports
  async generateCustomReport(reportParams) {
    try {
      return await ApiService.post('/reports/custom', reportParams);
    } catch (error) {
      throw error;
    }
  }

  async exportReport(reportType, filters = {}) {
    try {
      const queryParams = new URLSearchParams({
        type: reportType,
        ...filters,
      });

      // This will return a blob for file download
      const response = await fetch(
        `${ApiService.baseURL}/reports/export?${queryParams.toString()}`,
        {
          method: 'GET',
          headers: ApiService.getAuthHeaders(),
        }
      );

      if (!response.ok) {
        throw new Error(`Export failed: ${response.status}`);
      }

      return response.blob();
    } catch (error) {
      throw error;
    }
  }

  // System Analytics
  async getComplaintTrends(period = '30') {
    try {
      return await ApiService.get(
        `/analytics/complaint-trends?period=${period}`
      );
    } catch (error) {
      throw error;
    }
  }

  async getDepartmentPerformance() {
    try {
      return await ApiService.get('/analytics/department-performance');
    } catch (error) {
      throw error;
    }
  }

  async getSLACompliance() {
    try {
      return await ApiService.get('/analytics/sla-compliance');
    } catch (error) {
      throw error;
    }
  }

  // Notifications
  async sendNotification(notificationData) {
    try {
      return await ApiService.post('/notifications/send', notificationData);
    } catch (error) {
      throw error;
    }
  }

  async getNotifications(page = 0, size = 10) {
    try {
      const queryParams = new URLSearchParams({ page, size });
      return await ApiService.get(`/notifications?${queryParams.toString()}`);
    } catch (error) {
      throw error;
    }
  }
}

const adminServiceInstance = new AdminService();
export default adminServiceInstance;
